<div class="container">
  <h1 class="header">
    <div class="title">連携対象ユーザー設定</div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <app-biztel-account-mapping></app-biztel-account-mapping>
</div>
